export default "__VITE_ASSET__Bwzqd7hX__"